<div class="row d-flex justify-content-center">
  <div *ngFor="let model of sluitpottenModels; let i = index" class="sluitpot-wrapper col bg-white py-4 mx-2 my-2 rounded-4">
    <div>
      <label class="form-label"><b>* {{ "Sluitpot " + (i + 1) + ": " }}</b></label>
      <select
        class="form-select"
        [(ngModel)]="model.sluitpotCode"
        #sluitpotCode="ngModel"
        (change)="onSluitpotChanged(i)"
        required
      >
        <option value="" disabled selected hidden
          >Selecteer een waarde a.u.b.</option
        >
        <option
          *ngFor="let sluitpot of sluitpotten"
          value="{{ sluitpot.sluitpotCode }}"
          >{{ sluitpot.omschrijving }}</option
        >
      </select>
      <luv-validationError
        [show]="
          sluitpotCode.invalid &&
          (sluitpotCode.dirty || sluitpotCode.touched || validate)
        "
        [errorMessage]="getErrorMessage('sluitpotCode', 'required')"
      ></luv-validationError>
    </div>
    <div>
      <label class="form-label"><b>* Hart sluitpot:</b></label>
      <div class="input-group">
        <input
          #maat="ngModel"
          required
          type="number"
          min="0"
          class="form-control"
          aria-describedby="maatq1"
          [(ngModel)]="model.maat"
          (change)="onMaatQChanged(i)"
          [disabled]="!model.sluitpotCode"
          integerOnly
        />
        <span class="input-group-text">mm</span>
      </div>
      <luv-validationError
        [show]="maat.invalid && (maat.dirty || maat.touched || validate)"
        [errorMessage]="getErrorMessage('maat', 'required')"
      ></luv-validationError>
    </div>
    <!-- <div *ngIf="model.isNonBlinde">
      <label>* Maat Q2: <i class="fa fa-info-circle" (mouseenter)="showQ2Tooltip($event.target)" (mouseleave)="hideQ2Tooltip()"></i></label>
      <div class="input-group">
        <input
          #maat2="ngModel"
          required
          type="number"
          min="0"
          class="form-control form-control-sm"
          aria-describedby="maat2"
          [(ngModel)]="model.maat2"
          (change)="onMaatQChanged(i)"
          [disabled]="!model.sluitpotCode"
        />
        <div class="input-group-append">
          <div class="bg-primary pl-2 pr-2 pt-1 text-white">MM</div>
        </div>
      </div>
      <luv-validationError
        [show]="maat2.invalid && (maat2.dirty || maat2.touched || validate)"
        [errorMessage]="getErrorMessage('maat2', 'required')"
      ></luv-validationError>
    </div> -->
  </div>
</div>
<br>
